import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { LanguageService } from 'src/app/ecom-services/ecom-language-service';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { EcomItemDetailsPopupComponent } from '../ecom-item-details-popup/ecom-item-details-popup.component';
import { EcomCartService } from '@src/app/ecom-services/ecom-cart.service';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';

@Component({
    selector: 'app-ecom-item-upsell-grid',
    templateUrl: './ecom-item-upsell-grid.component.html',
    styleUrls: ['./ecom-item-upsell-grid.component.scss']
})
export class EcomItemUpsellGridComponent implements OnInit {
    @Input() upSellItems: any[] = [];

    //upSellItems: any[] = [];
    defaultImage: string = './assets/images/Itemdefault.jpeg';
    settings: any;
    locationSelected: any;
    userServiceBase: UserServiceBase;
    userSelectedStore: StoreServiceBase;
    itemDetailsModal: ItemBase;
    alerts: any[] = [{
        type: 'warning',
        msg: 'limit exceeds',
        timeout: 5000,
        isOpen: false
    }];
    onClose: any;
    item_pkid: any;
    iscvsd_pkid: any;
    upSellId: any;
    drawerVisible: boolean= false;
    constructor(private webstorage: EComWebStorage,
        public bsModalRef: BsModalRef,
        private modalService: BsModalService, public router: Router,
        private languageService: LanguageService,
        private cartService: EcomCartService,
    private settingService: EcomSettingService) {
        this.itemDetailsModal = new ItemBase();
    }

    ngOnInit() {
        this.settings = this.webstorage.sessionSt_settings;
        this.locationSelected = this.settingService.getCompanySetting();
        this.userServiceBase = this.webstorage.localSt_user_service_request;
    }
    hideModal() {
        this.cartService.updateCart(this.webstorage.sessionSt_cart_item, this.locationSelected.oocls_location_pkid);
        this.bsModalRef.hide();
    }
    onItemClick2(item) {
        const modalOptions = {
            ignoreBackdropClick: true,
            keyboard: false,
            animated: true,
            class: 'detail-modal col-xl-4 col-lg-5 col-md-6 col-sm-12 col-12',
            initialState: {
                onClose: this.hideModal.bind(this),
                item_pkid: item.item_pkid,
                iscvsd_pkid: item.iscvsd_pkid,
                upSellId: item.iuic_pkid
            }

        };
        debugger
        this.bsModalRef = this.modalService.show(EcomItemDetailsPopupComponent, modalOptions);

    }

    onDrawerVisibleChange($event){
        this.drawerVisible = false;
        this.cartService.updateCart(this.webstorage.sessionSt_cart_item, this.locationSelected.oocls_location_pkid);
      }

    onItemClick(item) {
        this.drawerVisible = true;
        this.onClose = this.onDrawerVisibleChange.bind(this);
        this.item_pkid = item.item_pkid;
        this.iscvsd_pkid = item.iscvsd_pkid;
        this.upSellId = item.iuic_pkid;
    }

}
